import script from "./MdFileRead.vue?vue&type=script&setup=true&lang=js"
export * from "./MdFileRead.vue?vue&type=script&setup=true&lang=js"

import "./MdFileRead.vue?vue&type=style&index=0&id=5e4c5a8c&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e4c5a8c"]])

export default __exports__